import styled from 'styled-components';
export const Container = styled.div `
  padding: var(--space-600);
`;
export const FieldsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-600);
`;
export const RedirectUrisContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const Label = styled.label `
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
`;
